import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import type { CreateProductInput, StripeProduct } from "./types";
import { CATALOG_PRODUCTS_QUERY_KEY } from "./use-products-list";

async function createProduct(input: CreateProductInput): Promise<StripeProduct> {
  return httpClient<StripeProduct>("/api/admin/catalog/products", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(input),
  });
}

export function useCreateProduct() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createProduct,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CATALOG_PRODUCTS_QUERY_KEY });
    },
  });
}
